import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Globalize from "globalize";
import Text from "components/form/text-inline";
import debounce from "lodash/debounce";
import { style } from "glamor";
import { DATATEST } from "constants/integration";

const stopPropagation = (e) => {
    e.stopPropagation();
};

class Notes extends PureComponent {
    static propTypes = {
        catalogEntry: PropTypes.object.isRequired,
    };

    styles = {
        description: {
            margin: "0px",
        },
        descriptionEditor: {
            minHeight: "220px",
            border: "0px",
            padding: "0px",
            cursor: "text",
        },
        container: style({
            position: "absolute",
            top: "0px",
            left: "0px",
            height: "280px",
            right: "0px",
            zIndex: 10,
            background: "rgba(255,255,255,.86)",
            padding: "8px",
            overflowY: "scroll",
            overflowX: "hidden",
        }),
    };

    constructor(props) {
        super(props);
        this.state = {
            notes: props.catalogEntry.notes || "",
        };

        this.handleNotesChange = debounce(this.handleNotesChange.bind(this), 600);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            this.setState({
                notes: nextProps.catalogEntry.notes || "",
            });
        }
    }

    handleNotesChange(notes) {
        const { catalogEntry, onUpdate } = this.props;
        onUpdate(catalogEntry, { notes });
    }

    render() {
        const { editable } = this.props;
        const { notes } = this.state;

        return (
            <div {...this.styles.container} onClick={stopPropagation}>
                <Text
                    dataTest={DATATEST.CATALOG.ITEM_PANEL_NOTES_INPUT}
                    style={this.styles.description}
                    editorStyle={this.styles.descriptionEditor}
                    placeholder={editable ? Globalize.formatMessage("Add notes here") : ""}
                    editable={editable}
                    form={true}
                    defaultValue={notes}
                    onChange={this.handleNotesChange}
                    label={Globalize.formatMessage("Product Notes")}
                />
            </div>
        );
    }
}

export default Notes;
